import Jasmiattic1 from '../../../media/SCG/Jasmia/12 a/Jasmia 12 Attic.webp'
import Jasmiattic2 from '../../../media/SCG/Jasmia/12 a/Jasmia 12 Attic L.webp'



const Jasmiatticimages =[
Jasmiattic1,Jasmiattic2
]

export default Jasmiatticimages;